import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyDKAbzpxFy2EX2lOySLZfF6DQc__Cu35DY",
  authDomain: "demoproject-b0ce8.firebaseapp.com",
  projectId: "demoproject-b0ce8",
  storageBucket: "demoproject-b0ce8.appspot.com",
  messagingSenderId: "106526816809",
  appId: "1:106526816809:web:70ad6bce4fed7333a03a38",
};

// Initialize Firebase
const fire = firebase.initializeApp(firebaseConfig);
export default fire;
